import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { sendOATResults } from '../../actions/device';

import DeviceCard from '../elements/DeviceCard';
import Heading from '../elements/PageHeading';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px auto 0px;
  alignitems: 'center';
`;

const Button = styled.button`
  color: ${props => props.theme.onPrimary};
  width: 180px;
  height: 85px;
  font-size: 18px;
  border: none;
  text-align: center;
`;

const OATResults = ({ target, organization, sendOATResults, t }) => {
  const [testSuitId, setTestSuitId] = useState('');

  useEffect(() => {
    const path = window.location.pathname;
    const parts = path.split('/');
    const testSuitIdFromPath = parts[parts.length - 1];
    setTestSuitId(testSuitIdFromPath);
  }, []);

  const handleClick = isAccepted => {
    const oatResults = {
      deviceCode: target.deviceCode,
      organization: organization,
      testSuitId: testSuitId,
      isAccepted: isAccepted,
    };

    sendOATResults(oatResults);
  };

  return (
    <Wrapper>
      <Heading text={t('management.OAT')} />
      <DeviceCard device={target || {}} />
      &nbsp;&nbsp;&nbsp;
      <Buttons>
        <Button
          style={{ background: '#67b419' }}
          onClick={() => handleClick(true)}
        >
          {t('management.OATAccept')}
        </Button>
        &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
        <Button
          style={{ background: '#e50b40' }}
          onClick={() => handleClick(false)}
        >
          {t('management.OATReject')}
        </Button>
      </Buttons>
    </Wrapper>
  );
};

const mapStateToProps = ({ device }) => ({
  target: device.target ? device.devices[device.target] : null,
  organization: device.devices[device.target].deviceOrganization,
});

const mapDispatchToProps = {
  sendOATResults,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(OATResults));
